import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UITextChipInput',
  props: {
    modelValue: null,
    placeholder: { default: '' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: string[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: string[], placeholder: string };





const inputRef = ref<HTMLInputElement | null>(null)
const inputValue = ref('')

const focusInput = () => {
  inputRef.value?.focus()
}

const addChip = (val: string) => {
  const trimmed = val.trim()
  if (!trimmed) return

  // Optional: Prevent duplicates? For emails maybe yes.
  if (!props.modelValue.includes(trimmed)) {
    emit('update:modelValue', [...props.modelValue, trimmed])
  }
  inputValue.value = ''
}

const removeChip = (index: number) => {
  const newValue = [...props.modelValue]
  newValue.splice(index, 1)
  emit('update:modelValue', newValue)
}

const handleInputConfirm = () => {
  addChip(inputValue.value)
}

const handleKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Enter' || event.key === ',') {
    event.preventDefault()
    handleInputConfirm()
  } else if (event.key === 'Backspace' && inputValue.value === '' && props.modelValue.length > 0) {
    // Remove last chip on backspace if input is empty
    removeChip(props.modelValue.length - 1)
  }
}

return { __sfc: true,props, emit, inputRef, inputValue, focusInput, addChip, removeChip, handleInputConfirm, handleKeydown }
}

})